import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FAQ } from 'src/app/models/um/organization';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-org-faqs',
  standalone: false,
  templateUrl: './org-faqs.component.html',
  styleUrl: './org-faqs.component.scss'
})
export class OrgFaqsComponent {
  faqs: FAQ[];
  appID:any;
  @Input() Content:any;
  userType: any;
  userDetails: any;
  accounts:string = "";
  IST_Display_Name:String;
  EAP_Display_Name:string;
  Grants_Display_Name:String;
  isIst:boolean = false;
  isEAP:boolean = false;
  orgDetails;
  isAdmin:boolean;
  isgrants:boolean = false;
  currentModule : any
  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    private userService: UserService,
    public modalRef: NgbActiveModal,
    public headerService: HeadService
  ) { }

  ngOnInit() {
    this.faqs = [];
    this.userType = this.userService.getUserType();

    this.userDetails = this.userService.getUserDetais();
    this.orgDetails = this.commonService.getOrgDetails();

    this.isAdmin = this.userDetails.IsAdmin;
    if(this.orgDetails!=null && this.orgDetails!=undefined)
    {
      this.IST_Display_Name = this.orgDetails[0].IST_DISPLAY_NAME;
      this.Grants_Display_Name = this.orgDetails[0].GRANTS_DISPLAY_NAME;
      this.EAP_Display_Name = this.orgDetails[0].EAP_DISPLAY_NAME;

      if (this.orgDetails[0].IST) {
        this.accounts = "ist";
        this.isIst = true;
      }
      if (this.orgDetails[0].EAP) {
        this.accounts = "eap";
        this.isEAP = true;
      }
    if (this.orgDetails[0].GRANTS) {
        this.accounts = "grants";
        this.isgrants = true;
      }
    }
   

    this.appID = this.Content.content.AppID;
    if (this.isIst)
      this.ModuleChange('IST');
    else if (this.isEAP)
      this.ModuleChange('EAP');
    else if (this.isgrants)
      this.ModuleChange('GRANTS');
  }


  ModuleChange(event:any){
    this.currentModule = event
    this.accounts = event;
    this.GetModuleAllFAQs(this.accounts);
  }

  GetModuleAllFAQs(userAccounts:any)
  {
    this.faqs=[];
    this.summaryService.getFAQByID('api/faq/getallFaqs/' + userAccounts).subscribe((result) => {
      if(result)
      {
        result.forEach(element => {
          if(element.TARGET_USER_TYPE == this.userType || element.TARGET_USER_TYPE == "B")
          {
            this.faqs.push(element)
          }
        });

        if (this.currentModule == "IST") { 
          this.faqs.sort((a, b) => a.IST_SEQ_NO - b.IST_SEQ_NO);
        }
        else if(this.currentModule == "GRANTS"){
          this.faqs.sort((a, b) => a.GRANTS_SEQ_NO - b.GRANTS_SEQ_NO);
        }
       else {
          this.faqs.sort((a, b) => a.EAP_SEQ_NO - b.EAP_SEQ_NO);
       }
      }
    });
  }

}
